import React, { useState, useEffect } from 'react';
import { useTranslation } from "react-i18next";
import { useParams, Link, useNavigate } from "react-router-dom";
import { IconArrowLeft, IconEdit } from "@tabler/icons-react";
import { getAthleteById } from "../../db";
import LoadinPage from "../../Components/LoadingPage";

import EditAthlete from "../../Components/EditForms/Athlete";

const Edit = () => {
    const { id } = useParams(); // ✅ Get athlete ID from URL
    const navigate = useNavigate(); // ✅ For redirecting if athlete is not found
    const { t } = useTranslation();

    const [athlete, setAthlete] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchAthlete = async () => {
            const foundAthlete = await getAthleteById(id);
            setLoading(false);

            if (foundAthlete) {
                setAthlete(foundAthlete);
            } else {
                navigate("/athletes", { state: { error: t("athletesDetail.notFound") } });
            }
        };
        fetchAthlete();
    }, [id, navigate]);

    if (loading) return (
        <div className="p-4 flex flex-col h-full relative">
            <div className="flex items-center pb-4 w-full">
                <div className="shrink-0 w-10">
                    <Link to={`/athletes`}>
                        <IconArrowLeft className="w-6 h-auto" />
                        <span className="sr-only">{t("athletesDetail.backToDetail")}</span>
                    </Link>
                </div>
                <div className="grow text-2xl uppercase text-center font-black transform -skew-x-12 shrink-0">
                </div>
                <div className="shrink-0 w-10">
                </div>
            </div>

            <div className="grow overflow-y-auto overflow-x-hidden">
                <LoadinPage />
            </div>
        </div>
    );

    return (
        <div className="p-4 flex flex-col h-full relative">
            <div className="flex items-center pb-4 w-full shrink-0">
                <div className="shrink-0 w-10">
                    <Link to={`/athletes/${athlete.id}`}>
                        <IconArrowLeft className="w-6 h-auto" />
                        <span className="sr-only">{t("athletesDetail.backToDetail")}</span>
                    </Link>
                </div>
                <div className="grow flex items-center justify-center gap-2">
                    <IconEdit className="w-4 h-auto" />
                    <h1 className=" text-2xl uppercase text-center font-black transform -skew-x-12 shrink-0">
                        {athlete.nickname || `${athlete.firstname} ${athlete.lastname}`}
                    </h1>
                </div>
                <div className="shrink-0 w-10"></div>
            </div>

            <div className="grow overflow-y-auto">
                <EditAthlete athlete={athlete} />
            </div>
        </div>
    );
};

export default Edit;
